import { useEffect } from 'react'
import InputBoxOnChange from '../inputbox/InputBoxOnChange';
import styled from 'styled-components';
import { useDialogStore } from 'src/stores/DialogStore';
import { NextButton, NextButtonWrapper } from '../common/CommonStyled';
import { LoadMapDataFilter } from './LoadMapData';

const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 80px;
    
    padding: 20px 24px;
`

const TitleWrapper = styled.div`
    font-size:16px; 
    font-weight:500;
    padding-bottom:10px;
`
const InputWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 1px;
`

const FilterComponent_LastVisit = () => {
    const temp_lastVisit = useDialogStore((state)=>state.temp_months_last_visit)
    const lastVisit = useDialogStore((state)=>state.months_last_visit)
    const setField = useDialogStore((state)=>state.setField)
    useEffect(()=>{
        setField('temp_months_last_visit',lastVisit)
    },[])

    const handleSubmit = async () => {
        await setField('months_last_visit',temp_lastVisit)
        LoadMapDataFilter()
        setField('isOpen',false)
    }

    const onClickReset = ()=>{
        setField('temp_months_last_visit',lastVisit)
    }

  return (
    <PageWrapper>
        <TitleWrapper>
            미방문 기간
        </TitleWrapper>
        <InputWrapper>
            <InputBoxOnChange
            type="number"
            value={
                temp_lastVisit === 0
                ? ''
                : temp_lastVisit > 99
                ? '99'
                : temp_lastVisit.toString()
            }
            placeholder="개월 수 입력"
            onChange={(e) => {
                if (Number(e.target.value) < 0) {
                    return
                }
                else if (Number(e.target.value) > 99) {
                setField("temp_months_last_visit", "99");
                } else {
                setField("temp_months_last_visit", e.target.value.toString());
                }
            }}
            isValid={true}
            />
            <span style={{ whiteSpace: "nowrap"}}>개월 이상 미방문</span>
        </InputWrapper>
        <NextButtonWrapper $isBorder={false}>
            <NextButton style={{background:'#F5F5F5', color:'#7F7F89', minWidth:'90px', width:'90px', boxShadow:'none', border:'1px solid #00001480'}} onClick={onClickReset}>초기화</NextButton>
            <NextButton onClick={handleSubmit} style={{margin:'5px',padding:'10px', height:'46px', boxShadow:'none'}}>적용</NextButton>
        </NextButtonWrapper>
    </PageWrapper>
  )
}

export default FilterComponent_LastVisit